/**
 * Purchase limits (ported from the old theme's N_MAX tag behavior in custom.js)
 *
 * Works with elements rendered by snippets/purchase-restrictions.liquid:
 *  - quantity inputs with [data-max-qty]                    -> clamped to the per-order max
 *  - add-to-cart buttons with [data-max-qty][data-product-id] -> disabled once the cart
 *    already holds the max quantity for that product
 */
(function () {
  'use strict';

  var MESSAGE_CLASS = 'purchase-limit-message';

  function limitMessage(max) {
    return 'Only maximum ' + max + ' quantity allowed per order';
  }

  function messageScope(el) {
    // One message per add-to-cart form (falls back to the immediate parent)
    return (
      el.closest('form') ||
      el.closest('product-form, .wt-product__add-to-cart_form--wrapper') ||
      el.parentNode
    );
  }

  function removeMessage(el) {
    if (!el || !el.parentNode) return;
    var scope = messageScope(el);
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('.' + MESSAGE_CLASS).forEach(function (msg) {
      msg.parentNode.removeChild(msg);
    });
  }

  function showMessage(afterEl, max) {
    if (!afterEl || !afterEl.parentNode) return;
    removeMessage(afterEl);
    var msg = document.createElement('div');
    msg.className = MESSAGE_CLASS;
    msg.setAttribute('role', 'alert');
    msg.textContent = limitMessage(max);
    msg.style.cssText = 'color:#c0392b;font-size:0.85em;margin-top:6px;width:100%;';
    afterEl.parentNode.insertBefore(msg, afterEl.nextSibling);
  }

  // ---------------------------------------------------------------------------
  // 1. Clamp quantity inputs with a per-order max
  // ---------------------------------------------------------------------------
  function clampInput(input) {
    var max = parseInt(input.getAttribute('data-max-qty'), 10);
    if (!max || max < 1) return;

    var effectiveMax = parseInt(input.getAttribute('max'), 10) || max;
    if (effectiveMax > max) effectiveMax = max;

    var value = parseInt(input.value, 10);
    if (isNaN(value)) return;

    if (value > effectiveMax) {
      input.value = effectiveMax;
      var wrapper = input.closest('.counter-wrapper') || input;
      showMessage(wrapper, max);
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[data-max-qty]')) {
      clampInput(e.target);
    }
  });

  document.addEventListener(
    'focusout',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('input[data-max-qty]')) {
        clampInput(e.target);
      }
    },
    true
  );

  // Also clamp right before an add-to-cart submit, in case counter JS bypassed
  // the change event (plus/minus buttons).
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var input = form.querySelector('input[data-max-qty]');
      if (input) clampInput(input);
    },
    true
  );

  // ---------------------------------------------------------------------------
  // 2. Disable add-to-cart buttons when the cart already holds the max
  // ---------------------------------------------------------------------------
  function syncButtonsWithCart() {
    var buttons = document.querySelectorAll('[data-max-qty][data-product-id]');
    if (!buttons.length) return;

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var quantities = {};
        (cart.items || []).forEach(function (item) {
          var id = String(item.product_id);
          quantities[id] = (quantities[id] || 0) + item.quantity;
        });

        buttons.forEach(function (button) {
          var max = parseInt(button.getAttribute('data-max-qty'), 10);
          var productId = String(button.getAttribute('data-product-id') || '');
          if (!max || !productId) return;

          var inCart = quantities[productId] || 0;
          var remaining = max - inCart;

          // Keep the quantity input in the same form within the remaining allowance
          var form = button.closest('form');
          var input = form ? form.querySelector('input[data-max-qty]') : null;
          if (input) {
            input.setAttribute('max', remaining > 0 ? remaining : 1);
            clampInput(input);
          }

          if (remaining <= 0) {
            if (!button.disabled) {
              button.disabled = true;
              button.setAttribute('data-limit-disabled', 'true');
            }
            showMessage(button, max);
          } else if (button.getAttribute('data-limit-disabled') === 'true') {
            button.disabled = false;
            button.removeAttribute('data-limit-disabled');
            removeMessage(button);
          }
        });
      })
      .catch(function (error) {
        console.log('[purchase-limits]', error);
      });
  }

  function scheduleSync() {
    setTimeout(syncButtonsWithCart, 1200);
    setTimeout(syncButtonsWithCart, 3000);
  }

  document.addEventListener('DOMContentLoaded', syncButtonsWithCart);

  // Re-sync after anything that can change the cart
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (
        e.target.closest(
          '.js-add-to-cart, [name="add"], .wt-cart__item__remove, .js-counter-button, .js-counter-increase, .js-counter-decrease'
        )
      ) {
        scheduleSync();
      }
    },
    true
  );
})();
